import { createContext, useContext } from "react";

export interface SettingSectionWrapperContextValue {
  groupId: string;
  /** When true, descendant settings use the compact (tight) highlight style. */
  compact: boolean;
}

/**
 * Published by `<SettingSectionWrapper>` so a descendant `<SettingWrapper>` knows
 * which group it belongs to. `undefined` means the setting is standalone (not
 * rendered inside any group).
 */
export const SettingSectionWrapperContext = createContext<
  SettingSectionWrapperContextValue | undefined
>(undefined);

export function useSettingSectionWrapperContext():
  | SettingSectionWrapperContextValue
  | undefined {
  return useContext(SettingSectionWrapperContext);
}
